(() => {
  class FAQPage {
    constructor(section) {
      this.section = section;
      this.list = section.querySelector('[data-faq-list]');
      this.items = [...section.querySelectorAll('[data-faq-item]')];
      this.searchInput = section.querySelector('.faq-page__search-input');
      this.clearButton = section.querySelector('.faq-page__search-clear');
      this.noResults = section.querySelector('.faq-page__no-results');

      if (!this.list) return;

      this.allowMultiple =
        section.dataset.allowMultiple === 'true';

      this.init();
    }

    init() {
      this.bindAccordion();
      this.bindSearch();
    }

    bindAccordion() {
      this.items.forEach((item) => {
        const button = item.querySelector('.faq-page__question');

        if (!button) return;

        button.addEventListener('click', () => {
          const isOpen =
            button.getAttribute('aria-expanded') === 'true';

          if (isOpen) {
            this.closeItem(item);
          } else {
            if (!this.allowMultiple) {
              this.items.forEach((otherItem) => {
                if (otherItem !== item) {
                  this.closeItem(otherItem);
                }
              });
            }

            this.openItem(item);
          }
        });
      });
    }

    openItem(item) {
      const button = item.querySelector('.faq-page__question');
      const answer = item.querySelector('.faq-page__answer-wrapper');

      if (!button || !answer) return;

      button.setAttribute('aria-expanded', 'true');
      answer.hidden = false;
    }

    closeItem(item) {
      const button = item.querySelector('.faq-page__question');
      const answer = item.querySelector('.faq-page__answer-wrapper');

      if (!button || !answer) return;

      button.setAttribute('aria-expanded', 'false');
      answer.hidden = true;
    }

    bindSearch() {
      if (!this.searchInput) return;

      this.searchInput.addEventListener(
        'input',
        () => this.filterFAQs()
      );

      if (this.clearButton) {
        this.clearButton.addEventListener(
          'click',
          () => {
            this.searchInput.value = '';
            this.filterFAQs();
            this.searchInput.focus();
          }
        );
      }
    }

    filterFAQs() {
      const searchTerm =
        this.searchInput.value
          .trim()
          .toLowerCase();

      let visibleCount = 0;

      this.items.forEach((item) => {
        const question =
          item.dataset.faqQuestion || '';

        const answer =
          item
            .querySelector('.faq-page__answer')
            ?.textContent
            .toLowerCase() || '';

        const matches =
          !searchTerm ||
          question.includes(searchTerm) ||
          answer.includes(searchTerm);

        item.classList.toggle(
          'is-hidden',
          !matches
        );

        if (matches) {
          visibleCount++;
        }
      });

      if (this.clearButton) {
        this.clearButton.hidden = !searchTerm;
      }

      if (this.noResults) {
        this.noResults.hidden =
          visibleCount !== 0;
      }
    }
  }

  const initFAQSections = (root = document) => {
    root
      .querySelectorAll('.faq-page')
      .forEach((section) => {
        if (section.dataset.faqInitialized === 'true') {
          return;
        }

        section.dataset.faqInitialized = 'true';

        new FAQPage(section);
      });
  };

  document.addEventListener(
    'DOMContentLoaded',
    () => initFAQSections()
  );

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initFAQSections(event.target);
    }
  );
})();